export default __webpack_public_path__ + "static/media/atomictortillastalliondraft_1cd6344b8d0d3d18d0022cf1948632d1.d82e9db7.png";